import { render, staticRenderFns } from "./AveineBottleImage.vue?vue&type=template&id=ceae6206&scoped=true"
import script from "./AveineBottleImage.vue?vue&type=script&lang=js"
export * from "./AveineBottleImage.vue?vue&type=script&lang=js"
import style0 from "./AveineBottleImage.vue?vue&type=style&index=0&id=ceae6206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceae6206",
  null
  
)

export default component.exports